import {useTranslation} from '@aboutyou/i18n';
import {TrackContentPageView} from '@aboutyou/tracking';
import {Button} from '@aboutyou/ui-components';
import React, {useEffect} from 'react';
import {useIsAuthenticated} from '../../features/Authentication/hooks/useIsAuthenticated';
import {useIsMissionsActive} from '../../features/Coins/utils/useIsMissionsActive';
import {useSubmitMissionProgress} from '../Coins/utils/useSubmitMissionProgress';
import {NewsletterLandingPage} from './NewsletterLandingPage';

export const SubscriptionConfirmationLandingPage = () => {
  const {t} = useTranslation();
  const {isAuthenticated} = useIsAuthenticated();
  const isMissionActive = useIsMissionsActive();
  const submitNewsletterMission = useSubmitMissionProgress({
    mission: 'newsletterMission',
  });

  useEffect(() => {
    if (isAuthenticated && isMissionActive) {
      submitNewsletterMission();
    }
  }, [isAuthenticated, isMissionActive]);

  return (
    <NewsletterLandingPage
      title={t('Thank you! Your registration was successful.')}
    >
      <TrackContentPageView
        pageTitle="subscriptionConfirmationLandingPage"
        overridePageProps={{type: 'newsletter'}}
      />
      <Button variant="primary" href={'/'} data-testid="continueShoppingButton">
        {t('Continue shopping')}
      </Button>
    </NewsletterLandingPage>
  );
};
